// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sandboxFlash {\n    font-size:40px;\n    color: yellow;\n    align-self:flex-start;\n  }", "",{"version":3,"sources":["webpack://./src/components/navigation/NavBar.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;EACvB","sourcesContent":[".sandboxFlash {\n    font-size:40px;\n    color: yellow;\n    align-self:flex-start;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
